import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useDispatch, useStore } from "react-redux";
import {
  IonAlert,
  IonBadge,
  IonButton,
  IonCard,
  IonCheckbox,
  IonContent,
  IonDatetime,
  IonLabel,
  IonLoading,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonProgressBar,
} from "@ionic/react";
import { decode } from "base64-arraybuffer";
import { useForm } from "react-hook-form";
import { talentFileUploader } from "../../data-services/assignmets";

import {
  adjustBackgroundHeight,
  adjustBorderHeight,
  getQrCodeInfo,
} from "../../common/common";
import ProfileFileuploaderQR27PUSH from "../../push-components/ProfileFileuploader/ProfileFileuploaderQR27PUSH";
import { headset } from "ionicons/icons";



const StepQR27PUSHUploadPhoto: React.FC = () => {
  const history = useHistory();

  const [fileName, setFileName] = useState('');
  const [talentHeadshot, setTalentHeadshot] = useState<string>("");

  const handleFileChange = (event:any) => {
    const file = event?.target?.files[0];
    if (file) {
      setFileName(file.name);
    }
  }

  const [qrDetails, setQrDetails] = useState<any>();
  const populateQrCodeInfo = () => {
    let qrDetails = getQrCodeInfo();
    setQrDetails(qrDetails);
  }

  const onRemoveCallback = useCallback(() => {
    setTalentHeadshot("");
    setFileName("");
  }, []);

    const submitPhotoHandler = async (event: any) => {
  
      event.preventDefault();
      let model_photo = new FormData(event.target);
      model_photo.append("type", "profile_photos");
  
      console.log("model_photo", model_photo);
      let file_upload: any = await talentFileUploader(model_photo, "");
  
      history.push('/QR27PUSHSuccess');
    };

  useEffect(() => {
    populateQrCodeInfo();
    adjustBorderHeight(800);
    adjustBackgroundHeight(800);
  }, []);

  const {
    handleSubmit,
    register,
    getValues,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      talent_mobile: "",
      talent_terms: false,
      talent_mobile_otp: "",
      promotion_text_msg: false,
      talent_fname: "",
      talent_lname: "",
      talent_display_name: "",
      talent_gender: "",
      talent_birth_date: "",
      talent_address: "",
      talent_apartment_no: "",
      talent_city: "",
      talent_country: "",
      talent_state: "",
      talent_email: "",
      marketing_emails: false,
      talent_passowrd: "",
      talent_zipcode: "",
    },
    mode: "onBlur",
  });


  return (
    <IonPage className={`lay--${qrDetails?.eventQrId}`}>

      <IonContent className={`lay__container--${qrDetails?.eventQrId}`}>
        <div className="lay__background">
          <img src="https://pulseqr.b-cdn.net/qr27PUSH/Background--no-logo.png" style={{height:'900px'}} />
        </div>

        {typeof qrDetails != 'undefined' && 
          <div className={`lay__content--${qrDetails?.eventQrId}`} style={{paddingLeft: '20px', paddingRight: '20px'}}>
            {true && 
              <div className="lay__logo" style={{height: '22px'}}>
                <div  className="">
                  <img style={{paddingTop: '20px', height: '22px', marginTop: '30px'}} src="https://pulseqr.b-cdn.net/qr27PUSH/logo.png" />
                </div>
                
              </div>
            }
            {fileName ? 
                <div className="img__first" style={{
                  marginTop: '50px',
                  marginBottom: '0',
                }}>
                  <div className="talent-signup__section-title talent-signup__section-title--smaller3" style={{paddingBottom: '0'}}>
                    <img src="https://pulseqr.b-cdn.net/qr27PUSH/p5-img1.png" />
                  </div>
                </div>
              :
                <div className="img__first" style={{
                  marginTop: '50px',
                  marginBottom: '25px',
                }}>
                  <div className="talent-signup__section-title talent-signup__section-title--smaller2" >
                    <img src="https://pulseqr.b-cdn.net/qr27PUSH/p4-img1.png" />
                  </div>
                </div>
              }
            

            <form id="psup__form" onSubmit={submitPhotoHandler}>
              <div className="">
                <ProfileFileuploaderQR27PUSH
                  name="head_shot"
                  limit="1"
                  id="model_headshot"
                  cropp_ratio="headshot"
                  files={[]}
                  click={onRemoveCallback}
                  handleFileChange={handleFileChange}
                />
              </div>

              <div className="img__inline" style={{marginTop: '0px', position: 'relative', zIndex: 3, width: '230px'}}>
                <IonButton
                  expand="block"
                  mode="ios"
                  type="submit"
                  disabled={!fileName}
                  style={{marginTop: '0px'}}
                  className="form__submit-img upload-photo__submit-btn"
                >
                  <img src={fileName ? "https://pulseqr.b-cdn.net/qr27PUSH/CTA-Submit5.png" : "https://pulseqr.b-cdn.net/qr27PUSH/CTA-Submit4.png"} />
                </IonButton>
              </div>
            </form>
          </div>}
      </IonContent>

    </IonPage>
  );
};

export default StepQR27PUSHUploadPhoto;
